const mutations = {
  columns(state, columns) {
    state.columns = columns
  },
  didLoadViewFail(state, didLoadViewFail) {
    state.didLoadViewFail = didLoadViewFail
  },
  isLoadingView(state, isLoadingView) {
    state.isLoadingView = isLoadingView
  },
  network(state, network) {
    state.network = network
  },
  viewStatus(state, viewStatus) {
    state.viewStatus = viewStatus
  },
}

export default mutations
